<template>
  <component
    :is="getCurrentDialog"
    v-bind="getDialogProps"
  />
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { authenticationService } from '../../_services';

export default {
    name: 'LoginDialogContainer',
    data() {
        return {
            dialogs: [
                'LetsBegin',
                'StudentRegister',
                'ShowVideo',
                'TellUsAboutYourself',
                'VerifyStudentData',
            ],
            show: false,
        };
    },
    computed: {
        ...mapGetters('authentication', {
            isLoggedIn: 'is_logged_in',
            hasRNE: 'has_rne',
            studentData: 'student_data',
        }),
        ...mapGetters('loginDialog', ['getCurrentDialog', 'getDialogProps', 'noEsc']),
        dialogTitles() {
            return {
                LetsBegin: '¡Comencemos!',
                StudentRegister: 'Registro',
                TellUsAboutYourself: 'Cuéntanos de ti',
                VerifyStudentData: !this.hasRNE ? 'Cuéntanos de ti' : 'Tus datos',
                ShowVideo: '',
            };
        },
    },
    watch: {
        getCurrentDialog: {
            handler() {
                this.$emit('changeCurrent', this.getCurrentDialog);
            },
            immediate: true,
        },
    },
    mounted() {
        this.setDialogs(this.dialogs);
        this.setNextDialog();
        this.show = true;
    },
    beforeDestroy() {
        this.clearDialogs();
        this.setDialogs('');
        this.show = false;
    },
    methods: {
        ...mapMutations('authentication', ['logout']),
        ...mapMutations('loginDialog', ['setDialogs', 'clearDialogs']),
        ...mapActions('loginDialog', ['setNextDialog']),
    },

};
</script>
